import cx from 'classnames'
import s from './chip-button.module.scss'

type Props = {
  children: React.ReactNode
  className?: string
  variant?: 'black' | 'white' | 'transparent'
} & React.HTMLAttributes<HTMLButtonElement>

export const ChipButton = ({
  children,
  className,
  variant = 'black',
  ...props
}: Props) => {
  return (
    <button
      className={cx(
        s.chip,
        className,
        { [s.black]: variant === 'black' },
        { [s.transparent]: variant === 'transparent' }
      )}
      {...props}
    >
      {children}
    </button>
  )
}
